<template>
  <FullscreenFrontageDialog ref="frontageDialog">
    <template slot-scope="dialogProps">
      <CopyLink :uid="dialogProps.uid"
                :title="dialogProps.title"
                :link="dialogProps.link"
                :source="dialogProps.source"
                @close="handleClose"/>
    </template>
  </FullscreenFrontageDialog>
</template>

<script>
import {FullscreenFrontageDialog} from '@/modules/common/components';
import CopyLink from '../components/CopyLink';

export default {
  name: "CopyLinkDialog",
  components: {FullscreenFrontageDialog, CopyLink},
  methods: {
    handleClose() {
      this.$refs.frontageDialog.handleClose();
    }
  }
}
</script>
